import { ButtonUiState } from '@/components/Common/Button/ButtonUi';

export type BuyerProfileUi = {
  buyerId?: string;
  assignKamOpen: boolean;
  moreActions?: ButtonUiState[];
  title: string;
};

export const initialState: BuyerProfileUi = {
  title: '',
  assignKamOpen: false,
};
